module.exports = __webpack_public_path__ + "img/time2.eb96ae2a.png";